{
  "_provenance": {
    "ns": "grants",
    "source": "the Grants page (es “Apoyos económicos”): pages/BillsPage.tsx, components/{bills,grants}/** and lib/{bills-display,grants-display,renewal-display}.ts (#2109 R3 lane L4)"
  },
  "expenseCategory": {
    "car_payment": "Car payment",
    "other": "Other",
    "otherWithDetail": "Other: {{detail}}",
    "rent_mortgage": "Rent or mortgage",
    "travel_lodging": "Travel: lodging near treatment",
    "travel_meals": "Travel: meals while away for treatment",
    "travel_mileage": "Travel: mileage and fuel",
    "utilities": "Utilities"
  },
  "filters": {
    "all": "All",
    "category": "Category",
    "grants": "Grants",
    "receipts": "Receipts",
    "scope": {
      "attention": "Needs attention",
      "paid": "Paid back",
      "review": "With TRF"
    }
  },
  "header": {
    "addExpense": "Add expense",
    "addReceipt": "Add a receipt",
    "filterLabel": "Filter grants",
    "searchPlaceholder": "Search your grants and receipts"
  },
  "page": {
    "deleteDialog": {
      "confirm": "Delete expense",
      "description": "It has not been sent to TRF, so nothing else changes. There is no undo.",
      "title": "Delete this expense?"
    },
    "howPayments": {
      "bank": "To change the bank account we pay into, update it yourself in Bill.com.",
      "changes": "Send us new statements and any payment changes within 30 days.",
      "fees": "TRF isn’t responsible for late fees or other extra charges.",
      "firstOfMonth": "Travel and Family Fun payments go out on the 1st of the month.",
      "signature": "Your Signature grant is paid once a month.",
      "title": "How payments work",
      "urgent": "Something urgent? Email your TRF case manager directly."
    },
    "noGrantsMatch": "No grants match.",
    "noReceiptsMatch": "No receipts match.",
    "notApprovedGrants": {
      "title_one": "Not approved ({{count}})",
      "title_other": "Not approved ({{count}})"
    },
    "pastGrants": {
      "help": "Questions about a decision?",
      "helpLink": "Get help",
      "title_one": "Past grant request ({{count}})",
      "title_other": "Past grant requests ({{count}})"
    },
    "pastReceipts": {
      "lede": "Paid back, approved or not approved.",
      "title_one": "Past receipt ({{count}})",
      "title_other": "Past receipts ({{count}})"
    },
    "status": {
      "allGood": "All on track",
      "nextPayment": "Next payment: {{month}}",
      "paid": "{{amount}} paid to you so far",
      "paused": "Payments are paused",
      "paymentDue": "Next payment: due since {{month}}",
      "renewalNeedsYou": "Your renewal needs you",
      "todo_one": "{{count}} receipt needs you",
      "todo_other": "{{count}} receipts need you"
    },
    "toast": {
      "deleted": "Expense deleted",
      "deleteFailed": "Couldn’t delete the expense",
      "expenseAdded": "Expense added",
      "expenseUpdated": "Expense updated",
      "replySent": "Sent back to TRF with your reply",
      "saveFailed": "Couldn’t save the expense"
    },
    "todo": {
      "lede": "Each one needs a photo, a detail or an answer before TRF can pay it back.",
      "title": "Finish these receipts"
    },
    "withTrf": {
      "lede": "Sent to TRF and waiting for a decision.",
      "title_one": "With TRF ({{count}})",
      "title_other": "With TRF ({{count}})"
    },
    "yourGrants": "Your grants"
  },
  "panel": {
    "empty": "No grants yet. When TRF approves a grant for your family, it appears here with its status and usage.",
    "loadFailed": "Couldn’t load your grants. Your grants are safe — this is a loading problem, not a change to your support."
  },
  "receipts": {
    "attach": "Attach a receipt",
    "heading": "Receipts against this grant",
    "line": "{{label}} · {{amount}}",
    "link": "Link",
    "none": "No receipts against this grant yet.",
    "noneAvailable": "No unlinked receipts. Add one above first.",
    "unlink": "Unlink receipt"
  },
  "remaining": {
    "leftOf": "<amount>{{amount}}</amount> <rest>left of {{approved}}</rest>",
    "overBudget": "Over budget"
  },
  "renewal": {
    "cta": {
      "continue": "Continue your renewal",
      "finish": "Finish your renewal",
      "start": "Start your renewal"
    },
    "inviteSuffix": "· {{line}}",
    "needsInfo": {
      "asked": "They asked about {{items}}.",
      "line": "TRF needs something from you before it can review your renewal."
    },
    "pendingLine": "{{title}}: <status>{{status}}</status>.",
    "reviewedLine": "TRF has reviewed your renewal and emailed you about it. If you can’t find the email, your case manager can help.",
    "year": "Year {{n}}",
    "yearSuffix": "— {{year}}"
  },
  "row": {
    "awardSetup": "TRF is setting up your grant. The amount and payment schedule will appear here.",
    "detailAndSchedule": "{{detail}} · {{schedule}}",
    "renewalSetup": "Your renewal was approved. TRF is setting up your grant.",
    "todo_one": "{{count}} to do",
    "todo_other": "{{count}} to do"
  },
  "signature": {
    "paidLine_one": "{{amount}} a month · {{count}} of {{months}} paid",
    "paidLine_other": "{{amount}} a month · {{count}} of {{months}} paid",
    "startedLine_one": "{{amount}} a month · {{count}} month · started {{month}}",
    "startedLine_other": "{{amount}} a month · {{count}} months · started {{month}}",
    "startsLine_one": "{{amount}} a month · {{count}} month · starts {{month}}",
    "startsLine_other": "{{amount}} a month · {{count}} months · starts {{month}}"
  },
  "status": {
    "approved": "Approved",
    "awarded": "Awarded",
    "denied": "Denied",
    "draft": "Draft",
    "fulfilled": "Closed",
    "submitted": "Pending",
    "under_review": "Pending",
    "withdrawn": "Withdrawn"
  },
  "type": {
    "family_fun": "Family Fun",
    "path_to_heaven": "Path to Heaven",
    "signature": "Signature",
    "travel": "Travel"
  },
  "usage": {
    "applied": "<amount>{{amount}}</amount> applied",
    "appliedPending": "<amount>{{amount}}</amount> applied · <pending>{{pending}}</pending> pending",
    "ofApproved": "of {{amount}} approved",
    "proof_one": "{{count}} receipt shows how {{amount}} was used",
    "proof_other": "{{count}} receipts show how {{amount}} was used"
  }
}
